import React, { useState, FC, useEffect } from "react";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, ISelectOption } from "@/components/YhFormBox/Types";
import { RouterParamType } from "@/model/navModel";
import { useDtpDetailModel } from "../dtpDetailModel";
import { customerService } from "@/views/base/customer/customerService";
import { useGlobalModel } from "@/model/globalModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";

export const FormBox: FC<RouterParamType> = ({ id, mode, formRef }) => {
    const {
        addFormVal,
        editFormVal,
        updateFormVal,
    } = useDtpDetailModel(({ addFormVal, editFormVal }) => [addFormVal, editFormVal]);

    const { fetchCustomerList } = useGlobalModel(() => []);
    const { getSelectedDictOne } = useDictModel(() => []);

    const formVal = mode === "edit" ? editFormVal : addFormVal;

    //回显选中客户带出来的数据
    const getCustomer = async (id: string) => {
        let { retData } = await customerService.one(id);
        let data = {
            customerCode: retData.code,
            customerName: retData.name,
            customerId: retData.id,
            phone: retData.phone,
            contact: retData.contact,
            countryCode: retData.countryCode,
            countryName: retData.countryName
        }
        updateFormVal(mode, data);
    }

    //客户选中
    const customerChange = (value: string, option: ISelectOption) => {
        if (option && option.id) {
            getCustomer(option.id as string)
        }
    }

    //币种选中
    const currencyChange = (value: string, option: ISelectOption) => {
        option && updateFormVal(mode, { currencyCode: option.value, currencyName: option.label });
    }

    //表单change
    const onChange = (changedValues: { [key: string]: any }, values: any) => {
        updateFormVal(mode, values);
    }

    const baseFormItem: IYhFormItemsBox = {
        title: "基础信息",
        style: { padding: "10px 0 0 0", marginBottom: "10px" },
        contentClass: "pr-2",
        items: [
            {
                type: FormItemTypeEnum.AsyncSelect,
                fieldLabel: "客户名称",
                fieldName: "customerCode",
                onSelectChange: customerChange,
                placeholder: "客户",
                rules: [{ required: true, message: "请选择客户" }],
                selectfetchList: fetchCustomerList,
                defaultQuery: formVal.customerName
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "币种",
                fieldName: "currencyCode",
                options: getSelectedDictOne(DictCodeEnmu.CURRENCY),
                onSelectChange: currencyChange,
                rules: [{ required: true, message: "请选择币种" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "所属部门",
                fieldName: "shopName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建人",
                fieldName: "createUser",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建时间",
                fieldName: "createTime",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "修改人",
                fieldName: "updateUser",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "修改时间",
                fieldName: "updateTime",
                disable: true
            },
            //带出
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户名称",
                fieldName: "customerName",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户名称",
                fieldName: "customerId",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "币种名称",
                fieldName: "currencyName",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "电话",
                fieldName: "phone",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系人",
                fieldName: "contact",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "国别名称",
                fieldName: "countryName",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "国别",
                fieldName: "countryCode",
                hidden: true
            }
        ]
    };

    const stockEntryFromConfig: IYhFormBox = {
        formRef,
        labelCol: { span: 8 },
        labelAlign: "right",
        formValues: formVal,
        onChange,
        boxs: [baseFormItem]
    }


    return (
        <YhFormBox {...stockEntryFromConfig} />
    )
}